import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fcmService } from '@/services/fcmService';

export const useFCMNavigation = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Set the navigation function in the FCM service
    fcmService.setNavigate(navigate);

    // Cleanup function
    return () => {
      fcmService.setNavigate(() => {
        console.warn('Navigation function not available');
      });
    };
  }, [navigate]);
}; 